import { LABEL_PLACEMENT } from 'baseui/checkbox';
import React from 'react';
import { Trans } from 'react-i18next';
import { TrackerUtil } from '../../../tracking/TrackerUtil';
import Checkbox from '../Checkbox';

interface CheckboxInputProps {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value: boolean;
}

const CheckboxInput: React.FC<CheckboxInputProps> = ({ onChange, value }) => {
  return (
    <Checkbox
      error={false}
      labelPlacement={LABEL_PLACEMENT.right}
      checked={value}
      onChange={(e) => {
        TrackerUtil.trackCheckboxClick(
          `${TrackerUtil.getPageName()}_checkbox_marketing-consent`,
          'checkbox_marketing-consent'
        );
        onChange(e);
      }}
      additionalTestId="marketing-consent"
    >
      <Trans
        i18nKey="pageContactDetailsMarketingConsentCheckboxText"
        tOptions={{ skipPostProcessing: true }}
      />
    </Checkbox>
  );
};

export { CheckboxInput };
